import { setupTelemetry, getLogger as getProvideLogger, type TelemetryConfig } from '@provide-io/telemetry';

let initialized = false;

export function setup(environment: 'development' | 'production', buildVersion: string): void {
  if (initialized) return;
  initialized = true;

  const config: Partial<TelemetryConfig> = {
    serviceName: 'sprite',
    environment,
    version: buildVersion,
    logLevel: environment === 'production' ? 'info' : 'debug',
    logFormat: 'pretty',
    consoleOutput: true,
    captureToWindow: true,
    otelEnabled: false,
    metricsEnabled: false,
  };
  setupTelemetry(config);
}

export function log(module: string) {
  return getProvideLogger(module);
}
